import type { IconSvgObject } from './types';

const DeleteRowIcon: IconSvgObject = [
  ["path", { d: "M6 21.5H5.5C3.84315 21.5 2.5 20.1569 2.5 18.5V5.5C2.5 3.84315 3.84315 2.5 5.5 2.5H18.5C20.1569 2.5 21.5 3.84315 21.5 5.5V18.5C21.5 20.1569 20.1569 21.5 18.5 21.5H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 21.5L12 18.5M12 18.5L15 15.5M12 18.5L9 15.5M12 18.5L15 21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 9L21.5 9", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8.5 2.5L8.5 9M15.5 2.5L15.5 9", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default DeleteRowIcon;
